<template>
	<div class="closeout-cart-wrapper" @mouseenter="open" @mouseleave="close">
		<a :href="cartUrl" class="btn btn-primary cart-btn text-nowrap">
			MY ORDER REQUEST ({{ cartCount }})
		</a>
		<div v-if="isOpen" class="closeout-cart-dropdown">
			<h6 class="closeout-cart-dropdown-title">Order Request</h6>

			<div v-if="loading" class="text-center py-3">
				<div class="spinner-border spinner-border-sm text-primary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>

			<template v-else-if="items.length">
				<table class="table table-sm closeout-cart-table mb-2">
					<thead>
						<tr>
							<th>Description</th>
							<th>Qty</th>
							<th>UoM</th>
							<th>Price</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in items" :key="item.cart_item_key">
							<td>
								{{ item.name }}
								<div class="text-muted small">SKU: {{ item.sku }}</div>
							</td>
							<td class="text-center">{{ item.quantity }}</td>
							<td>{{ item.unit }}</td>
							<td>${{ item.line_total }}</td>
							<td>
								<button
									class="closeout-cart-remove"
									aria-label="Remove item"
									:disabled="item._removing"
									@click.prevent="$emit('remove', item)"
								>
									<span
										v-if="item._removing"
										class="spinner-border spinner-border-sm"
									></span>
									<span v-else>&times;</span>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="d-flex justify-content-end align-items-center mb-2">
					<strong class="me-2">Est. Product Total</strong>
					<span v-html="cartTotal"></span>
				</div>
				<div class="d-flex justify-content-end">
					<a :href="checkoutUrl" class="btn btn-sm btn-primary">CREATE REQUEST</a>
				</div>
			</template>

			<p v-else class="text-muted text-center py-3 mb-0">Your order is empty.</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CloseoutCartDropdown',
	props: {
		cartCount: { type: Number, default: 0 },
		cartTotal: { type: String, default: '$0.00' },
		cartUrl: { type: String, default: '/cart' },
		checkoutUrl: { type: String, default: '/checkout' },
		items: { type: Array, default: () => [] },
		loading: { type: Boolean, default: false },
	},
	emits: ['open', 'remove'],
	data() {
		return { isOpen: false };
	},
	methods: {
		open() {
			this.isOpen = true;
			this.$emit('open');
		},
		close() {
			this.isOpen = false;
		},
	},
};
</script>
